<div fxLayout="column" fxLayoutGap="10px" style="padding-bottom: 5px;font-family: Roboto, Helvetica Neue, sans-serif;">
  <mat-form-field>
    <mat-select placeholder="Filtrer sur un état..."
                [formControl]="stateControl"
                [matTooltip]="'Filtrer sur un état...'"
                (selectionChange)="onSelected($event)">
      <ng-container>
        <mat-option *ngFor="let state of states" [value]="state">
          <div [innerHTML]="depositSvc.getChipButtonByState(state)" [attr.data-cy]="'btn-filter-state-deposit' + state.uid"></div>
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
  <div>
    <button color="accent" class="mat-button mat-small" mat-raised-button (click)="onValidate($event)" matTooltip="Filtrer" data-cy="btn-state-deposit-filtering">Filtrer</button>&nbsp;
  </div>
</div>
